import React, { Component } from 'react';
import appstore from './appstore.svg';
import cupperLogo from './CupperLogo.png'
import api from './api.js';
import {ref} from './firebase.js'
import DocumentMeta from 'react-document-meta'

class Meta extends Component {
  render() {
    const meta = {
      title: "Cupper | " + this.props.cafe.name,
      meta: {
        property: {
          'og:title': "Cupper",
          'og:description': this.props.cafe.name,
          'og:url': "https://cafe.cupperapp.com/?cafe="+this.props.cafeKey,
          'og:image': this.props.cafe.imageLink,
          'twitter:card': 'summary_large_image',
          'twitter:site': '@cupperapp',
          'twitter:creator': '@cupperapp',
          'twitter:title': 'Cupper',
          'twitter:description': this.props.cafe.name,
          'twitter:image': this.props.cafe.imageLink
        }
      },
      extend: true
    }

    return (
      <DocumentMeta {...meta}></DocumentMeta>
    )
  }
}

class ConnectionMessage extends Component {
  render() {
    if (this.props.status === 100) {
      return (
        <h3>Brewing together your Uber account with Cupper</h3>
      )
    } else if (this.props.status === 200) {
      return (
        <div>
          <h1 className="display-4 subtitle">You're Almost There</h1>
          <p className="lead">You will now see the best coffee spots near your destination in your Uber feed the next time you're on a trip.</p>
          <p className="lead">For the best experience, please download our app.</p>
          <a href="https://itunes.apple.com/us/app/cupper-the-ultimate-coffee-experience/id1014894569?mt=8">
            <img style={{height: '60px'}} src={appstore} alt="App Store download button" />
          </a>
        </div>
      )
    } else if (this.props.status === 204) {
      return (
        <div>
          <h1 className="display-4 subtitle">Oops!</h1>
          <p className="lead">You will need to download Cupper to get access to your Trip Experience.</p>
          <p className="lead"><strong>To finish up, install Cupper</strong></p>
          <a href="https://itunes.apple.com/us/app/cupper-the-ultimate-coffee-experience/id1014894569?mt=8">
              <img src={appstore} alt="App Store download button" />
          </a>
        </div>
      )
    } else if (this.props.status === 0) {
      return (
        <div>
          <h3>Cupper works with your Uber app to show you the best coffee spots near your destination in your Uber feed while on a ride.</h3>
          <p className="lead">To get started, make sure you have Cupper and Uber installed on your iPhone.</p>
          <a href="https://itunes.apple.com/us/app/cupper-the-ultimate-coffee-experience/id1014894569?mt=8">
                <img src={appstore} alt="App Store download button" />
          </a>
          <p className="lead">Head to the Uber app to connect.</p>
          <a className="btn btn-secondary" href="uber://appgallery">Connect with Uber</a>
        </div>
      )
    } else {
      return (
        <div>
          <h2>There was an error.</h2> 
          <p className="lead">Head back to the Uber app to try again.</p>
          <a className="btn btn-secondary" href="uber://appgallery">Go Back to Uber</a>
        </div>
      )
    }
  }
}

class ConnectionContainer extends Component {
  render() {
    return (
      <div className="site-wrapper-inner">
        <div className="cover-container">
          <div className="masthead clearfix">
          </div>
          <div className="inner cover row justify-content-center">
            <div className="col-10">
              <h1 className="cover-heading">Cupper + Uber</h1>
              <ConnectionMessage status={this.props.status} key={this.props.key} />
            </div>
          </div>
          <div className="mastfoot">
          </div>
        </div>
      </div>
    )
  }
}

class CafeContainer extends Component {
  render() {
    let cardStyle = {
      marginTop: '25px',
      marginBottom: '25px', 
      width: '23rem', 
      color: 'rgb(25,25,25)',
      textShadow: 'none'
    }

    let cupperCardLogoStyle = {
      margin: '5px',
      height: '40px'
    }

    let iconStyle = {
      margin: "0",
      padding: "0"
    }

    return(
        <div>
        <Meta cafe={this.props.cafe} cafeKey={this.props.cafeKey}/>
        <div className="container">
          <div className="row justify-content-center">
            <div className="card align-self-center" style={cardStyle}>
              <div className="card-header">
                <img className="cupper-card-logo"  src={cupperLogo} alt="Cupper Logo" style={cupperCardLogoStyle} />
              </div>
              <img className="card-img-top img-fluid" src={this.props.cafe.imageLink} alt="Cafe" />
              <h3 className="card-header">{this.props.cafe.name}</h3>
              <ul className="list-group list-group-flush">
                <li className="list-group-item text-left"><i className="fa fa-address-book col-1" style={iconStyle} aria-hidden="true"></i><div className="col-11">{this.props.cafe.address}</div></li>
                <li className="list-group-item text-left"><i className="fa fa-phone col-1" style={iconStyle} aria-hidden="true"></i><div className="col-11">{this.props.cafe.phone}</div></li>
                <li className="list-group-item text-left">
                  <div className="col-1" style={iconStyle}><i className="fa fa-clock-o" style={iconStyle} aria-hidden="true"></i></div>
                  <div className="col-11 row">
                    <div className="col-4">Monday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.mondayOpen) ? formatFromMilitaryTime(this.props.cafe.mondayOpen)+"-" : "CLOSED"} {formatFromMilitaryTime(this.props.cafe.mondayClose)}</div>
                    <div className="col-4">Tuesday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.tuesdayOpen) ? formatFromMilitaryTime(this.props.cafe.tuesdayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.tuesdayClose)}</div>
                    <div className="col-4">Wednesday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.wednesdayOpen) ? formatFromMilitaryTime(this.props.cafe.wednesdayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.wednesdayClose)}</div>
                    <div className="col-4">Thursday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.thursdayOpen) ? formatFromMilitaryTime(this.props.cafe.thursdayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.thursdayClose)}</div>
                    <div className="col-4">Friday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.fridayOpen) ? formatFromMilitaryTime(this.props.cafe.fridayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.fridayClose)}</div>
                    <div className="col-4">Saturday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.saturdayOpen) ? formatFromMilitaryTime(this.props.cafe.saturdayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.saturdayClose)}</div>
                    <div className="col-4">Sunday:</div><div className="col-7"> {formatFromMilitaryTime(this.props.cafe.sundayOpen) ? formatFromMilitaryTime(this.props.cafe.sundayOpen)+"-" : "CLOSED"}  {formatFromMilitaryTime(this.props.cafe.sundayClose)}</div>
                  </div>
                </li>
              </ul>
              <div className="card-footer text-muted text-center">
                For the best experience, <br/>please download Cupper
                <br />
                <a href="https://itunes.apple.com/us/app/cupper-the-ultimate-coffee-experience/id1014894569?mt=8">
                  <img style={{height: '60px', marginTop: '10px'}} src={appstore} alt="App Store download button" />
                </a>
              </div>
            </div>
          </div>
        </div>
        </div>
    ) 
  }
}

class Connecting extends Component {

  constructor(props) {
    super(props);

    this.state = {
      code: "",
      message: "Connecting...",
      status: 100,
      key: "",
      cafe: {}
    }

    this.exchangeCode = this.exchangeCode.bind(this)
    this.updateMessage = this.updateMessage.bind(this)
    this.getCafe = this.getCafe.bind(this)
  }

  exchangeCode(code) {
    api.submitUberCode(code)
      .then((response) => {
        this.updateMessage(response);
      })
  }

  updateMessage(stat) {
    if (stat === 200) {
      this.setState({
        message: "CONNECTED!",
        status: stat
      })
    } else if (stat === 400) {
      this.setState({
        message: "ERROR",
        status: stat
      })
    } else if (stat === 200) {
      this.setState({
        message: "Download App",
        status: stat
      })
    } else if (stat === 0) {
      this.setState({
        message: "CupperUber",
        status: stat
      })
    } else {
      this.setState({
        message: "unknown error",
        status: 0
      })
    }
  }

  getCafe(key) {
    if (key) {
      ref.child('/cafes/').child(key).once('value').then((snapshot) => {
        let cafeVal = snapshot.val()
        if (cafeVal) {
          this.setState({
            cafe: cafeVal
          })
        }
      })
    }
  }

  componentDidMount() {
    if (this.props.location.search.includes("cafe")) {
      var id = this.props.location.search.replace('?cafe=','')
      if (id.includes('&uid')){
        id = id.substring(0, id.indexOf('&uid'));
      }
      console.log(id)
      this.setState({
        key: id
      })
      console.log(id)
      this.getCafe(id)
    } else {
      if (this.props.location.search.includes('?code=')) {
        let id = this.props.location.search.replace('?code=','');
        let code = id;
        this.exchangeCode(code);
      } else {
        this.updateMessage(0);
      }
    }
  }

  render() {
    if (this.state.key !== "") {
      return <CafeContainer cafe={this.state.cafe} cafeKey={this.state.key}/>
    } else {
      return <ConnectionContainer status={this.state.status} key={this.state.key} />
    }

    
  }
}

function formatFromMilitaryTime(hours, currentTime, openingTime) {
  console.log("Current TIme" + currentTime + openingTime);

  var hoursString = "";
  if (hours < 0) {
    hoursString = "CLOSED";
  } else if (hours < 1200) {
    hoursString = hours + " AM";
  } else if (hours < 1260) {
    hoursString = hours + " PM";
  } else if (hours === 2400) {
    hoursString = "1200 AM";
  } else {
    var normTime = hours - 1200;
    hoursString = normTime + " PM"; 
  }

  if (openingTime) {
    if (hours < Number(currentTime)) {
      hoursString = "CLOSED";
    }
  } else if (hoursString.includes("-")) {
    hoursString = "CLOSED"
  } else if (hoursString === "") {
    hoursString = "CLOSED"
  } else {
    if (hours > Number(currentTime)) {
      hoursString = "CLOSED";
    }
  }
  if (hoursString !== "CLOSED") {
    var len = hoursString.length;
    var hoursFormatted = hoursString.substring(0, len-5) + ":" + hoursString.substring(len-5);
  };

  if (hoursString){
    return hoursFormatted;
  } else {
    return "CLOSED"
  }
  
}

export default Connecting;


// WEBPACK FOOTER //
// ./src/Connecting.js